/* global fbq */
import React, { useEffect } from "react";
import "./styles.scss";
import greenCheckIcon from "../../images/home/green-check-icon.svg";
import Header from "../HeaderNew/component";
import Footer from "../../components/common/Footer";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const ThankYou = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orderDetails = location.state?.orderDetails
  const orderAmount = location.state?.orderAmount

  useEffect(() => {
    loadFacebookPixel({ orderAmount: orderDetails?.orderAmount || 0, orderId: orderDetails?.orderId || "" });
  }, []);

  const loadFacebookPixel = ({ orderAmount, orderId }) => {
    if (
      process.env.REACT_APP_NODE_ENV === "production" &&
      typeof window !== 'undefined'
      &&
      !window.location.href.includes('localhost')
      && localStorage.getItem("landingSource")?.includes("qc")
    ) {
      const postData = {
        appType: "Buyer-app",
        eventName: "Purchase",
        orderId: orderId
      };
      axios.post(`${process.env.REACT_APP_KIKO_API_BASE_URL_V2?.replace("ondc-seller", "ondc-buyer")}/add-event`, postData)
        .then(response => {
          console.log('Response:', response.data);
        })
        .catch(error => {
          console.error('Error:', error.response ? error.response.data : error.message);
        });
      //Avoid injecting multiple times
      if (window.fbq) {
        fbq('track', 'Purchase', { value: orderAmount, currency: 'INR' });
        return;
      }
      fbq('init', '326242339368504');
      fbq('track', 'PageView');
      fbq('track', 'Purchase', { value: orderAmount?.toFixed(2), currency: 'INR' });
      fbq('track', 'Complete Registration');
      // Optional: Add <noscript> image if desired
      const noscriptImg = document.createElement('img');
      noscriptImg.src =
        'https://www.facebook.com/tr?id=326242339368504&ev=PageView&noscript=1';
      noscriptImg.height = 1;
      noscriptImg.width = 1;
      noscriptImg.style.display = 'none';
      document.body.appendChild(noscriptImg);
    }
  };

  return (
    <>
      <Header />
      <div className="thank-you-container">
        <div className="thank-you-container-inner">
          <div className="thank-you-header">
            <img
              src={greenCheckIcon}
              alt="Icon"
              className="thank-you-header-icon"
            />
            <div className="thank-you-header-title">Thank You for Shopping with Us!</div>
          </div>
          <div className="thank-you-text">
            <div className="thank-you-text-title">{`Your order for ${orderDetails?.itemsCount ?? ""
              } Item(s) worth ₹${orderAmount?.toFixed(2) ?? ""
              } has been confirmed.`}</div>
            <div className="thank-you-text-title">
              {`Order ID: `}
              <a
                href="/buyer-order-details"
                className="thank-you-text-title"
                onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
                onMouseOut={(e) => (e.target.style.textDecoration = "none")}
                onClick={() => {
                  localStorage.removeItem("cart");
                  navigate(localStorage.getItem("slug"));
                  navigate("/", { replace: true })
                  navigate("/buyer-order-details", {
                    state: { orderId: orderDetails?._id },
                  });
                }}
              >
                {`${orderDetails?.orderId}`}
              </a></div>
            <div className="thank-you-text-small-title">Updates on delivery will be shared shortly.</div>
            <div className="thank-you-btn-group">
              <button
                onClick={() => {
                  localStorage.removeItem("cart");
                  navigate(localStorage.getItem("slug"));
                  navigate("/", { replace: true })
                  navigate("/buyer-order-details", {
                    state: { orderId: orderDetails?._id },
                  });
                }}
                className="btn btn-outline-primary thank-you-button">View Order Details</button>
              <button
                onClick={() => {
                  localStorage.removeItem("cart");
                  navigate("/", { replace: true })
                  navigate("/seller?pid=" + orderDetails?.providerId);
                }}
                className="btn btn-primary thank-you-button">Continue Shopping</button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ThankYou;
